import { Styler } from '@honeycomb/ui-core';
import * as React from 'react';
export function HeroContent(props) {
    return React.createElement(Styler, Object.assign({ c: "common.white", "data-hero-content": true }, props));
}
